module.exports = __webpack_public_path__ + "static/media/4.473df5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/4.jpg
// module id = 1736
// module chunks = 0